import React, { useState, useEffect, useMemo } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useParams } from 'react-router-dom';
import { identity, pickBy } from 'lodash';
import { useCollect } from 'hooks';

const Students = ({ tab, setTab }) => {
	// Store subject's id
	const { id } = useParams();

	// Update selected tab
	useSingleEffect(() => setTab(tab));

	// Cache search data
	const [search, setSearch] = useState({
		page: 1
	});

	// Store request parameters
	const parameters = useMemo(() => pickBy({
		type: 'student:final',
		eager: 'student',
		finalId: id,
		page: search.page
	}, identity), [search, id]);

	// Store requested materials
	const [[collection, progress], collect] = useCollect('finals', parameters);

	// Collect materials on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	console.log(collection);

	return (
		<>
			{/* Show loading progress */}
			{/* <Progress progress={progress} /> */}

			{/* <div className="mt-4 bg-white dark:bg-neutral-800 rounded-lg divide-y divide-neutral-100 dark:divide-neutral-700">
				{collection?.map(student =>
					<Student key={student.id} student={student} />
				)}
			</div> */}
		</>
	);
};

export default Students;
